/*
 * @Author: lishiqiao
 * @Date: 2022-01-18 14:35:44
 * @LastEditors: lishiqiao
 * @LastEditTime: 2022-03-18 16:11:59
 */
import http from "@/axios/index";
import Page from "@/utils/methods/page"

export default {
    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 10:16:59
     * @description: 销售量--查询顶级机构下的所有机构
     * @param {*} rootId
     */
    getVolumeCompanyList(rootId) {
        const url = `/desktopReport/querySelltOrg/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 10:18:42
     * @description: 客户应收--汇总--查询顶级机构下的所有机构
     * @param {*} rootId
     */
    getSummaryCompanyList(rootId) {
        const url = `/desktopReport/queryCustomerOrg/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 10:19:49
     * @description: 客户应收--明细--查询顶级机构下的所有机构
     * @param {*} rootId
     */
    getDetailsCompanyList(rootId) {
        const url = `/desktopReport/queryCustomerOrgMingXi/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 10:20:43
     * @description: 客户应收--明细--查询顶级机构下的所有客户
     * @param {*} rootId
     */
    getDetailsCustomersList(rootId) {
        const url = `/desktopReport/queryCustomerMingXi/${rootId}`;
        return http.get(url)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 10:23:35
     * @description: 销售概览-销售量报表-育苗分页
     * @param {*} params
     */
    getVolumePageList(params) {
        const url = `/outSaleDailyOrg/searchOutSaleDailyOrgList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 10:24:17
     * @description: 销售概览-销售量报表分页-（养成、育苗）分页导出
     * @param {*} params
     */
    exportVolumeData(params) {
        const url = `/outSaleDailyOrg/exportOutSaleDailyOrgList`;
        return Page.exportDatas(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 10:24:58
     * @description: 销售概览-客户应收养成育苗分页查询
     * @param {*} params
     */
    getCustomersPageList(params) {
        // const url = `/outMoneyReceive/getoutMoneyReceive`;旧
        const url = `/outMoneyReceive/getPresidentOutMoneyReceiveList`;
        return http.post(url, params)
    },

    /**
     * @Author: lishiqiao
     * @Date: 2022-01-19 10:25:24
     * @description: 销售概览-养成育苗客户应收分页导出
     * @param {*} params
     */
    exportCustomersData(params) {
        // const url = `/outMoneyReceive/exportoutMoneyReceiveList`;
        const url = `/outMoneyReceive/exportPresidentOutMoneyReceiveList`;
        return Page.exportDatas(url, params)
    },
}